import React from "react";
function ProjectCard({ ahref, title, content, bgimg }) {

 

  return (
    <div className="bg-transparent group cursor-pointer group perspective h-[300px] w-[220px] ">
      <div className="relative preserve-3d group-hover:my-rotate-y-180 w-full h-full duration-1000 ">
        <div className="absolute backface-hidden w-full h-full border-4 border-project-sc">
          <img src={bgimg} className="w-full h-full object-cover" alt='' />

        </div>
        <div className="absolute my-rotate-y-180 backface-hidden w-full h-full bg-gray-100 overflow-hidden border-4 border-project-sc">
          <div className="text-center flex flex-col items-center justify-center h-full text-gray-800 px-2 pb-24">
            <h1 className="text-project-pr text-2xl font-semibold">{title}</h1>

            <p className="text-lg text-project-sc font-[400] leading-4 mt-4">
              {content}
            </p>
            <a className="bg-project-button text-project-pr bottom-4 fixed px-6 py-2 font-semibold " href={ahref} target="_blank">Projeye Git</a>
          </div>
        </div>
      </div>
    </div>

  );
}

export default ProjectCard;
